<template>
  <v-main>
    <v-container class="fill-height" fluid>
      <v-row align="center" justify="center">
        <v-card class="elevation-12" max-width="500" width="100%">
          <v-toolbar color="primary" dark flat>
            <v-toolbar-title>{{ $t("common.login") }}</v-toolbar-title>
            <div class="flex-grow-1"></div>
          </v-toolbar>

          <v-card-text
            class="d-flex justify-center align-center flex-column"
            v-if="ssoAvailable"
          >
            <v-btn @click="azureLoginClicked"
              ><v-icon color="primary" class="mr-2">mdi-microsoft</v-icon>
              {{ $t("user.loginMicrosoft") }}</v-btn
            >
          </v-card-text>

          <v-divider v-if="ssoAvailable" />

          <v-col cols="12" sm="122" md="12">
            <v-form @submit.prevent="handleSubmit">
              <v-card-text>
                <v-text-field
                  :label="$t('common.email')"
                  name="email"
                  prepend-icon="person"
                  type="text"
                  v-model="email"
                ></v-text-field>

                <v-text-field
                  id="password"
                  :label="$t('common.password')"
                  name="password"
                  prepend-icon="lock"
                  type="password"
                  v-model="password"
                ></v-text-field>
                <v-btn to="/forgot" text color="primary"
                  >{{ $t("user.forgotPassword") }}
                </v-btn>
              </v-card-text>
              <v-card-text
                style="
                  width: 90%;
                  margin: 0 auto;
                  border-radius: 10px;
                  background-color: rgb(238, 85, 85);
                  color: white;
                "
                v-if="errorMessage != null"
              >
                <h3 style="width: 90%; margin: 0 auto">{{ errorMessage }}</h3>
              </v-card-text>
              <v-card-actions>
                <div class="flex-grow-1"></div>
                <v-btn color="primary" type="button" @click="openTosDialog"
                  >{{ $t("common.login") }}
                </v-btn>
              </v-card-actions>
            </v-form>

            <tos-dialog
              ref="tosDialog"
              :email="email"
              @accepted="handleSubmit"
            />
          </v-col>
        </v-card>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import { mapActions, mapGetters, mapState, mapMutations } from "vuex";
import TosDialog from "@/components/license/TosDialog.vue";
import msal from "@/msal";

export default {
  name: "Login",
  components: {
    TosDialog,
  },

  data() {
    return {
      email: "",
      password: "",
      submitted: false,
      errorMessage: null,
    };
  },
  computed: {
    ...mapState("users", ["status", "userCompany", "currentUser"]),
    ...mapGetters("configuration", ["ssoAvailable"]),
  },

  created() {
    this.logout();
  },

  methods: {
    ...mapActions("users", {
      login: "login",
      logout: "logout",
      getUser: "getUser",
      afterLoginActions: "afterLoginActions",
    }),
    ...mapMutations("users", ["SET_SSO", "SET_TOKEN", "LOGIN_USER"]),
    ...mapActions("configuration", ["getCompanySettings"]),

    async azureLoginClicked() {
      await msal.login();

      // Set the token to be used to fetch the "me" endpoint to get the user information if it exists
      let token = await msal.getToken();
      this.SET_SSO(true);
      this.SET_TOKEN();
      let result = await this.getUser();
      if (result.sc !== 200) {
        this.SET_SSO(false);
        this.SET_TOKEN(null);
        this.errorMessage = this.$t("user.errors.noUserFoundMicrosoft");
        return;
      }

      result.data.token = token;
      this.LOGIN_USER(result.data);

      await this.afterLoginActions();
      this.$router.push("/landing");
    },

    openTosDialog() {
      if (this.email !== undefined && this.email !== "")
        this.$refs.tosDialog.openDialog();
    },

    async handleSubmit(e) {
      if (e !== undefined && typeof e === "object") e.preventDefault();

      this.submitted = true;
      const { email, password } = this;
      if (email && password) {
        try {
          this.SET_SSO(false);
          let result = await this.login({ email, password });

          if (
            result &&
            Object.keys(this.currentUser).length !== 0 &&
            Object.keys(this.userCompany).length !== 0
          ) {
            await this.getCompanySettings();
            this.$router.push("/landing");
          }
        } catch (e) {
          this.errorMessage = e;
        }
      }
    },
  },
};
</script>
